import { graphql } from "relay-runtime"

export const deUpdateProgressNoteEpisodeOfCareMutation = graphql`
  mutation deUpdateProgressNoteEpisodeOfCareMutation(
    $input: De_updateProgressNoteEpisodeOfCareInput!
    $addConnections: [ID!]!
    $removedConnections: [ID!]!
  ) {
    updateProgressNoteEpisodeOfCare: de_updateProgressNoteEpisodeOfCare(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      updateProgressNoteEpisodeOfCareOutput: de_UpdateProgressNoteEpisodeOfCareOutput {
        progressNote @prependNode(connections: $addConnections, edgeTypeName: "de_ProgressNoteEdge") {
          id @deleteEdge(connections: $removedConnections)
          ...deProgressNoteFragment @relay(mask: false)
          ...deProgressNoteFragment
        }
        currentEpisodeOfCare {
          id
          updatedAt
        }
        oldEpisodeOfCare {
          id
          updatedAt
        }
      }
    }
  }
`
